"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var appConfig_1 = __importDefault(require("../../../config/appConfig"));
var lineAuth_1 = require("../../../util/lineAuth");
var SocialLoginPanel_module_scss_1 = __importDefault(require("./SocialLoginPanel.module.scss"));
var LineAuthButton = function (_a) {
    var onError = _a.onError, disabled = _a.disabled;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(false), isRedirecting = _b[0], setIsRedirecting = _b[1];
    var lineChannelId = (0, react_1.useMemo)(function () { return appConfig_1.default.getLineChannelId(); }, []);
    var startLineLogin = function () {
        if (!lineChannelId) {
            onError(t("LINE_AUTH_ERROR_MISSING_CHANNEL_ID"));
            return;
        }
        var state = (0, lineAuth_1.generateRandomToken)();
        var nonce = (0, lineAuth_1.generateRandomToken)();
        var redirectUri = (0, lineAuth_1.buildLineRedirectUri)();
        window.sessionStorage.setItem(lineAuth_1.LINE_STATE_STORAGE_KEY, state);
        window.sessionStorage.setItem(lineAuth_1.LINE_NONCE_STORAGE_KEY, nonce);
        setIsRedirecting(true);
        (0, lineAuth_1.redirectTo)((0, lineAuth_1.buildLineAuthorizeUrl)({
            channelId: lineChannelId,
            redirectUri: redirectUri,
            state: state,
            nonce: nonce
        }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: SocialLoginPanel_module_scss_1.default.googleLoginWrapper, children: [(0, jsx_runtime_1.jsxs)("button", { type: "button", className: "".concat(SocialLoginPanel_module_scss_1.default.loginButton, " ").concat(SocialLoginPanel_module_scss_1.default.googleButton, " ").concat(SocialLoginPanel_module_scss_1.default.lineButton), disabled: disabled || isRedirecting || !lineChannelId, onClick: startLineLogin, children: [(0, jsx_runtime_1.jsx)("span", { className: "".concat(SocialLoginPanel_module_scss_1.default.googleIconBox, " ").concat(SocialLoginPanel_module_scss_1.default.lineIconBox), "aria-hidden": "true", children: "LINE" }), (0, jsx_runtime_1.jsx)("span", { className: SocialLoginPanel_module_scss_1.default.googleButtonLabel, children: t("LINE_AUTH_BUTTON_LABEL") })] }), isRedirecting ? ((0, jsx_runtime_1.jsx)("p", { className: SocialLoginPanel_module_scss_1.default.googleHintText, children: t("LINE_AUTH_HINT_REDIRECTING") })) : null] }));
};
exports.default = LineAuthButton;
